export const LAYOUT = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
